import { useState } from "react";
import PromptManagementStyles from "./PromptManagement.module.scss";
import { useAppDispatch } from "../../../../hooks/store";
import { updateClause } from "../../store/admin.thunk";
import { PromptsForFeature } from "../../constants";
import Typography from "../../../../components/Typography/Typography";
import { SimpleButton } from "../../../../components/Buttons/Buttons";
import { AccordionDetailsCompForContractReview } from "./PromptManagementForContractReview";
import editIcon from "../../../../assets/images/edit.svg";
import { IconButton } from "@mui/material";

export default function PromptManagementForContractReviewCard({
  prompt,
  setIsSelectedSubclause,
}: any) {
  const dispatch = useAppDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [dataObj, setDataObj] = useState({
    id: "",
    name: "",
    value: "",
    isDefaultVal: false,
  });

  const handleOnClose = (e: any) => {
    e.stopPropagation();
    setIsEditing(false);
  };

  const updateLocalState = () => {
    const rulesCopy = prompt?.rules?.slice();
    const ruleIdx = rulesCopy?.findIndex(
      (rule: any) => rule?.name === dataObj?.name
    );
    if (ruleIdx > -1) {
      rulesCopy[ruleIdx].count = parseFloat(dataObj?.value);
    }
    setIsSelectedSubclause({
      ...prompt,
      rules: rulesCopy,
    });
  };

  const handleSave = async () => {
    await dispatch(
      updateClause({
        feature: PromptsForFeature.CONTRACT_REVIEW,
        clauseId: dataObj?.id,
        name: dataObj?.name,
        value: dataObj?.value,
        isDefaultVal: dataObj?.isDefaultVal,
      })
    );
    updateLocalState();
    setDataObj({ id: "", name: "", value: "", isDefaultVal: false });
    setIsEditing(false);
  };
  return (
    <div className={PromptManagementStyles.ttcClauseCard}>
      <div className={PromptManagementStyles.ttcClauseCardHeader}>
        <Typography
          fontSize={14}
          fontWeight={500}
          lineHeight="20px"
          color="#000000CC"
        >
          Threshold
        </Typography>
        {/* !isEditing &&  */}
        {
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              setIsEditing(true);
            }}
          >
            <img src={editIcon} alt="" />
          </IconButton>
        }
      </div>
      <div
        className={PromptManagementStyles.promptTextContainer}
        style={{
          padding: "0px 0px 16px 0px",
          backgroundColor: "transparent",
        }}
      >
        <div className={PromptManagementStyles.promptTextContainer}>
          {prompt?.rules?.map((item: any, idx: number) => (
            <AccordionDetailsCompForContractReview
              key={item?.name}
              item={item}
              isEditing={isEditing}
              setDataObj={setDataObj}
              labelRule={prompt?.labelRules[idx]}
              labelDescription={prompt?.threshold[idx]}
              id={prompt?.id}
              style={{
                width: "80%",
              }}
            />
          ))}
        </div>

        <div>
          {isEditing && (
            <div className={PromptManagementStyles.editAndCancelBtns}>
              <SimpleButton
                variant="outlined"
                onClick={handleOnClose}
                style={{ borderRadius: "24px" }}
              >
                <Typography fontSize={12} fontWeight={500} lineHeight="20px">
                  Cancel
                </Typography>
              </SimpleButton>
              <SimpleButton
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSave();
                }}
                style={{ borderRadius: "24px" }}
              >
                <Typography fontSize={12} fontWeight={500} lineHeight="20px">
                  Save
                </Typography>
              </SimpleButton>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
